import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=c49fa726&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=ts&"
export * from "./edit.vue?vue&type=script&lang=ts&"
import style0 from "./edit.vue?vue&type=style&index=0&id=c49fa726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49fa726",
  null
  
)

export default component.exports